// import Image from "next/image";
// import { appendHttpsToUrl, generateUniqueComponentKey } from "helpers/Helper";
// import styles from "./NextImage.module.css";
// import "./NextImage.css";

// const NextImage = (props) => {

//   //Add module styling as well normal classes so that both will work for nested styling/classes
//   let classes = "";
//   if(props.className){
//     classes = props.className + " " + props.className.split(' ').map(currentClass => styles[currentClass]).join(" ");
//   }
//   return (
//     <>
//       <Image
//         src={props.publicUrl ||
//           (props.ImageUrl
//             ? appendHttpsToUrl(props.ImageUrl)
//             : `${process.env.S3_IMAGE_URL}/${props.isMobile ? "sm_" : "md_"}${
//                 props.Name || props.name
//               }`)
//         }
//         alt={props.Alt_Text || "image"}
//         title={props.Title}
//         className={classes}
//         width={props.width}
//         height={props.height}
//         style={props.style}
//         key={props.keyGenerate == false ? "" : generateUniqueComponentKey()}
//         priority={props.fetchpriority}
//         loading={props.isLazyload ? "lazy" : "eager"}
//         sizes={props.Sizes}
//       />
//     </>
//   );
// }

// export default NextImage;

import Image from "next/image";
import { appendHttpsToUrl } from "helpers/Helper";
import styles from "./NextImage.module.css";
import "./NextImage.css";
import { useMemo } from "react";

const NextImage = (props) => {
  const normalizedStyle = useMemo(() => {
    const baseStyle = props.style ? { ...props.style } : {};
    const hasWidthControl =
      "width" in baseStyle || "maxWidth" in baseStyle || "minWidth" in baseStyle;
    const hasHeightControl =
      "height" in baseStyle || "maxHeight" in baseStyle || "minHeight" in baseStyle;

    if (hasWidthControl && !hasHeightControl) {
      baseStyle.height = "auto";
    }
    if (hasHeightControl && !hasWidthControl) {
      baseStyle.width = "auto";
    }

    return baseStyle;
  }, [props.style]);

  // Memoize class names to avoid unnecessary computations
  const classes = useMemo(() => {
    if (props.className) {
      return (
        props.className +
        " " +
        props.className
          .split(" ")
          .map((currentClass) => styles[currentClass])
          .join(" ")
      );
    }
    return "";
  }, [props.className]);

  // Memoize image source to avoid unnecessary reloads
  const src = useMemo(() => {
    return (
      props.publicUrl ||
      (props.ImageUrl
        ? appendHttpsToUrl(props.ImageUrl)
        : `${process.env.S3_IMAGE_URL}/${props.isMobile ? "sm_" : "md_"}${
            props.Name || props.name
          }`)
    );
  }, [props.publicUrl, props.ImageUrl, props.isMobile, props.Name, props.name]);

  const priority = Boolean(props.fetchpriority);

  return (
    <Image
      src={src}
      alt={props.Alt_Text || "image"}
      title={props.Title}
      className={classes}
      width={Number(props.width) || 300}
      height={Number(props.height) || 200}
      style={normalizedStyle}
      key={props.keyGenerate === false ? "" : props.ImageUrl || props.Name} // Use stable key
      priority={priority}
      {...(!priority
        ? { loading: props.isLazyload === false ? "eager" : "lazy" }
        : {})}
      sizes={props.Sizes}
    />
  );
};

export default NextImage;
